module.exports = "/_next/static/images/takahashiminami-a7adb1c2af32b304faa5aa3efacf44e4.jpg";